import React, { useState, useEffect } from 'react';
import './Claim.css';
import Modal from '../Modal';

const Claim = ({ claimAmount, claimAvailable, vContract }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalProps, setModalProps] = useState({
      title: '',
      message: '',
      txHash: '',
      error: '',
      isLoading: false,
    });

    const closeModal = () => {
      setModalOpen(false);
      setModalProps({
        title: '',
        message: '',
        txHash: '',
        error: '',
        isLoading: false,
      });
    };

    const claim = async() => {
      try {
        setModalOpen(true);
        setModalProps({
         title: 'Claiming...',
         message: 'Please wait while your claim transaction is being processed.',
         isLoading: true,
         txHash: '',
         error: ''
        });

        const result = await vContract.claimTokens();
        const receipt = await result.wait();

        setModalProps({
          title: 'Transaction Successful',
          message: 'Your transaction has been completed successfully.',
          isLoading: false,
          txHash: receipt.hash,
          error: ''
       });
      } catch (error) {
        setModalProps({
          title: 'Transaction Failed',
          message: 'There was an error processing your transaction.',
          isLoading: false,
          txHash: '',
          error: error.message,
       });
      }
    }

  return (
    <section id="claim">
    <div className="claim">
      {claimAvailable ? (
        <>
          <p className="claim-header">Tokens available to claim:</p>
          <div className="countdown">
            <p>{claimAmount}</p>
          </div>
          <button 
            className="claim-button" 
            onClick={claim}
            // Optionally disable the button if timeLeft is zero
          >
            Claim Now
          </button>
        </>
      ) : (
        <>
          <p className="claim-header">No time to claim</p>
        </>
      )}
    </div>
    {/* Reusable Modal Component */}
    <Modal
        isOpen={modalOpen}
        title={modalProps.title}
        message={modalProps.message}
        txHash={modalProps.txHash}
        error={modalProps.error}
        isLoading={modalProps.isLoading}
        onClose={closeModal}
      />
    </section>
    
  );
};

export default Claim;
